module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Gardner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John Gardner (1933–1982) was born in Batavia, New York. His critically acclaimed books include the novels "), _c('I', [_vm._v("Grendel")]), _vm._v(", "), _c('I', [_vm._v("The Sunlight Dialogues")]), _vm._v(", and "), _c('I', [_vm._v("October Light")]), _vm._v(", for which he received the National Book Critics Circle Award, as well as several works of nonfiction and criticism such as "), _c('I', [_vm._v("On Becoming a Novelist")]), _vm._v(". He was also a professor of medieval literature and a pioneering creative writing teacher whose students included Raymond Carver and Charles Johnson.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Y4Igei/images/cover.jpg?1733085642849",
      "alt": "This image is the cover for the book King's Indian"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("King's Indian\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p'), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "line-height": "200%"
    }
  }, [_c('b', [_vm._v("An iconic collection that showcases Gardner as a master craftsman navigating an uncertain world")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "line-height": "200%"
    }
  }, [_vm._v("In this exceptional book, author John Gardner explores the literary form as a vehicle of vision, and creates heroes that personify his tremendous artistic ideals: A Boston schoolmaster abandons his dreams of owning a farmhouse in rural Illinois only to be taken on a voyage across the seas and into self-discovery, faith, and love; an artist’s rapturous enthusiasm inspires an aging university professor to approach life’s chaotic moments as opportunities for creation. Each of these stories is wonderful in its own right, and provides valuable insight into the author’s literary beliefs.    ")]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "line-height": "200%"
    }
  }), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "line-height": "200%"
    }
  }, [_vm._v("Written just prior to his critical masterwork, "), _c('i', [_vm._v("On Moral Fiction")]), _vm._v(", "), _c('i', [_vm._v("The King’s Indian ")]), _vm._v("is a must-read for those interested in learning more about Gardner’s highly controversial artistic philosophies.")]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "line-height": "200%"
    }
  }), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "line-height": "200%"
    }
  }, [_vm._v("This ebook features a new illustrated biography of John Gardner, including original letters, rare photos, and never-before-seen documents from the Gardner family and the University of Rochester Archives.")]), _c('p'), _c('p'), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0